// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SwitcherChart_wrapper__faA_l","hide":"SwitcherChart_hide__jl2qw"};